import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { migrationStatusActions } from './migration-status.actions';
import { MigrationStatusState } from './migration-status.types';

export const migrationStatusInitialState: MigrationStatusState = {};

export const migrationStatusReducer = createImmerReducer(
  migrationStatusInitialState,
  on(migrationStatusActions.loadedMigrationStatus, (state, { boardId, migrationStatus }) => ({
    ...state,
    [boardId]: migrationStatus,
  })),
  on(migrationStatusActions.loadedMigrationStatusWithoutParams, (state, { boardId }) => ({
    ...state,
    [boardId]: {},
  })),
  on(migrationStatusActions.reloadMigrationStatus, (state, { boardId }) => ({
    ...state,
    [boardId]: { ...state[boardId], inProgress: true },
  }))
);
